import $ from 'jquery';
import React from 'react';
import Helmet from 'react-helmet';
import Img from "gatsby-image";

import Navbar from '../components/navbar/navbar';
import MainLayout from '../layouts/layout';
import Button from '../components/button/button';
import SuperHeader from '../components/typographies/superheader';
import Header1 from '../components/typographies/header1';
import Header2 from '../components/typographies/header2';
import Header3 from '../components/typographies/header3';
import Header4 from '../components/typographies/header4';
import Para1 from '../components/typographies/para1';
import Para2 from '../components/typographies/para2';
import FancyRadio from '../components/form/fancyRadio';
import Testimonial from '../components/testimonial/testimonial'
import ProjectList from '../components/list/projectList';

import RockstarsBlue from '../static/RockstarsBlue.svg';
import SpinningElbowStrip from '../static/images/SpinningElbowStrip@2x.png';
import DesiGyaanStrip from '../static/images/DesiGyaanStrip@2x.png';

import DarkBG from '../static/images/services/BG.svg';
import Development from '../static/images/services/Development.svg';
import Designer from '../static/images/services/Designer.svg';
import Branding from '../static/images/services/Branding.svg';
import Business from '../static/images/services/Business.png';

import Link from 'gatsby-link'

export default class Project extends React.Component {
  // event handler
  scrollToProjectForm(e) {
    e.preventDefault();

    $('html, body').animate({
      scrollTop: $("#project-form").offset().top - 20
    }, 500);
  }

  handlePostProjectClick(e) {
    e.preventDefault();

    window.open('https://surebro.typeform.com/to/iNM0dJ', '_blank');
  }
  // render methods
  render() {
    const projects = [
      {
        title: 'Juerix: A Designer Jewellery Marketplace',
        subtitle: 'Juerix is a jewellery marketplace based in Bangkok. They curate jewellery designers before adding them to the Juerix network. Everything you see on Juerix is guaranteed to be top notch. They wanted their marketplace to visually communicate their brand while also do what marketplaces are supposed to do, Sell',
        link: '/case-studies/juerix',
        actionText: 'Read Case Study',
        imageUrl: 'https://res.cloudinary.com/surebro/image/upload/q_auto/v3-static/JuerixStrip_2x.7119d0c4',
        backgroundSize: '700px',
        tags: [{
          tag: 'Branding',
          label: 'Branding'
        },
        {
          tag: 'Design',
          label: 'UI Design'
        },
        {
          tag: 'Develop',
          label: 'Development'
        }],
      },
      // {
      //   title: 'Checkoutly: Making Selling Online Easy',
      //   subtitle: 'Social Commerce is a big phenomenon in Southeast Asia but managing a successful Social Commerce store is tedious. Checkoutly wanted to solve this problem and we helped do just that.',
      //   link: '/case-studies/checkoutly',
      //   actionText: 'View Project',
      //   imageUrl: '/static/images/musingsStrip@2x.png',
      //   backgroundSize: '500px',
      //   tags: [{
      //     tag: 'Branding',
      //     label: 'Branding'
      //   },
      //   {
      //     tag: 'Design',
      //     label: 'UI Design'
      //   },
      //   {
      //     tag: 'Develop',
      //     label: 'Development'
      //   }],
      // },
      // {
      //   title: 'Spinning Elbow',
      //   subtitle: 'The founders of Spinning Elbow realised that the key to standing out in a competitive space is strong branding. We designed a Brand Identity for Spinning Elbow to help them connect with their target customers',
      //   link: '/case-studies/spinning-elbow',
      //   actionText: 'Read Case Study',
      //   imageUrl: SpinningElbowStrip,
      //   backgroundSize: '700px',
      //   tags: [{
      //     tag: 'Branding',
      //     label: 'Branding'
      //   }],
      // },
      // {
      //   title: 'DesiGyaan',
      //   subtitle: 'Would this game work in India if we changed it a little bit. We built an MVP to test just that. DesiGyaan is an iOS game built with a Bollywood twist',
      //   link: '/case-studies/desigyaan',
      //   actionText: 'Read Case Study',
      //   imageUrl: DesiGyaanStrip,
      //   backgroundSize: '700px',
      //   tags: [{
      //     tag: 'Design',
      //     label: 'UI Design'
      //   },
      //   {
      //     tag: 'Develop',
      //     label: 'IOS Development'
      //   }],
      // },
    ];
    return (
      <MainLayout key="main-layout">
        <Helmet>
          <title>Surebro: We build web applications to grow your business</title>
          <meta name="description" content="We design and build web applications to help you grow your business" />
          <meta property="og:url" content="https://surebro.com/" />
          <meta property="og:title" content="Surebro: We build web applications to grow your business" />
          <meta property="og:description" content="We design and build web applications to help you grow your business" />
          <meta property="og:image" content="https://res.cloudinary.com/surebro/image/upload/v1530280290/Social-share-cover_t18uos.png" />
        </Helmet>
        <Navbar key="navbar" active={1} className="blue" />
        <div className="container" style={{ marginTop: '160px' }}>
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-10 col-xs-12">
              <Header1
                  key="header"
                  className="text-center stronger"
                  text="We build Design First Applications to help you grow your Business"
                  decoration={{ text: 'Design First Applications', type: 'underline', color: 'blue' }}
              />
              <Para1
                  key="design-centric-subtitle"
                  className="text-center grey"
                  text="We are a small team of product designers & developers obsessed with creating products that fuel growth"
              />
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-xs-12 col-sm-6">
              <div className="row justify-content-center">
                <Button
                    key="primary-button"
                    onClick={this.scrollToProjectForm.bind(this)}
                    text="Get Started Now"
                    className="blue center-block margin-t-20"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid margin-t-60 project-strip" style={{
          backgroundImage: `url(https://res.cloudinary.com/surebro/image/upload/q_auto/v3-static/ProjectStrip_2x.773ed153)`
        }}>

        </div>
        <div className="container margin-t-100">
          <div className="row justify-content-center">
            <div className="row justify-content-center">
              <div className="col-lg-8 col-md-8 col-xs-12">
                <Header1
                    key="header"
                    className="text-center stronger"
                    text="Design First, Release Fast"
                />
                <Para1
                    key="sub-title"
                    className="text-center grey light"
                    text="Solving problems might not be enough. If we do not delight our users, they won't stick. So we design our apps with great focus to delight while also solving real problems."
                />
                <Para1
                    key="sub-title-2"
                    className="text-center grey light"
                    text="But solving a non-existant problems helps no one. So we release fast, iterate faster, gather feedback and continue building."
                />
              </div>
            </div>
          </div>
        </div>
        <div className="container margin-t-100">
          <div className="row justify-content-center">
            <Header1
                key="services-title"
                className="text-center"
                text="Our Services"
            />
          </div>
          <div className="row justify-content-center">
            <div className="col-md Service-box">
              <div className="Service-box-image-wrapper">
                <img className="img img-responsive Service-box-image" src={Development} />
              </div>
              <div className="Service-box-content">
                <Header4
                    key="web-dev"
                    className="text-left"
                    text="Web & Mobile Development"
                />
                <Para2
                    key="web-dev-subtitle"
                    className="text-left grey"
                    text="Performance is key. The best ideas will fail if the application does not perform. We make sure your product performs in all scenarios."
                />
              </div>
              <a href="https://surebro.typeform.com/to/iNM0dJ" className="button Service-box-button blue text-center" target="__blank">
                Get Started
              </a>
            </div>
            <div className="col-md Service-box">
              <div className="Service-box-image-wrapper">
                <img className="img img-responsive Service-box-image" src={Designer} />
              </div>
              <div className="Service-box-content">
                <Header4
                    key="web-dev"
                    className="text-left"
                    text="UI & UX Design"
                />
                <Para2
                    key="web-dev-subtitle"
                    className="text-left grey"
                    text="We design to communicate clearly & provide seemless experiences through smooth, intuitive & delightful interfaces across all devices."
                />
              </div>
              <a href="https://surebro.typeform.com/to/iNM0dJ" className="button Service-box-button blue text-center" target="__blank">
                Get Started
              </a>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col Service-box large dark" style={{ backgroundImage: `url(${DarkBG})`}}>
              <div className="Service-box-content">
                <Header2
                    key="contact-title"
                    className="text-center strong white"
                    text="Have the Idea but no one to build it?"
                />
                <br />
                <Para1
                    key="contact-subtitle"
                    className="text-center regular white"
                    text="We can take your idea, your napkin sketch and build your product. Together with you we'll bring your idea to life"
                />
              </div>
              <Button
                  key="contact-us-button"
                  text="Let's Talk"
                  className="Service-box-button-large margin-t-20 blue "
                  link="mailto:projects@surebro.com"
                  isLink
              />
            </div>
          </div>
        </div>
        <div className="container-fluid margin-t-100">
          <div className="row justify-content-center header-wrapper">
            <Header1
                key="project-title"
                className="text-center"
                text="Projects we have worked on"
            />
          </div>
          <ProjectList
              key="project-list"
              projects={projects}
              color="blue"
          />
        </div>
        <div className="container margin-t-60">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <div className="row align-items-center">
                <div className="col-md">
                  <img src={RockstarsBlue} className="img-fluid rounded mx-auto d-block img-max-h-450" alt="People ready to help you" />
                </div>
                <div id="project-form" className="col-md margin-t-20">
                  <Header1
                      key="project-title"
                      className="text-left light"
                      text="What can we help you with?"
                  />
                  <form className="margin-t-60">
                    <FancyRadio
                        key="web-app-radio"
                        id="web-app"
                        name="project-type"
                        text="Web Development"
                        className="margin-t-20"
                    />
                    <FancyRadio
                        key="mobile-app-radio"
                        id="mobile-app"
                        name="project-type"
                        text="UX & UI Design"
                        className="margin-t-20"
                    />
                    <FancyRadio
                        key="web-design-radio"
                        id="web-design"
                        name="project-type"
                        text="Brand Identity Design"
                        className="margin-t-20"
                    />
                    <FancyRadio
                        key="design-radio"
                        id="design"
                        name="project-type"
                        text="Business Consultation"
                        className="margin-t-20"
                    />
                  </form>
                  <Button
                      key="primary-button"
                      onClick={this.handlePostProjectClick.bind(this)}
                      text="Let's do it"
                      className="blue center-block margin-t-40 btn-block"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </MainLayout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/index.js